import {Swiper, Navigation, Pagination} from 'swiper/dist/js/swiper.esm.js'
import {break_sm} from "../../js/constants";

Swiper.use([Pagination, Navigation]);

(function () {
  if (!document.querySelector('.itemsBlog')) return;
  const firstInnerWidth = document.querySelector('.firstInner').offsetWidth;
  const itemBlogWidth = document.querySelector('.itemBlog').offsetWidth;

  new Swiper('.itemsBlog__slider', {
      speed: 500,
      slidesPerView: 'auto',
      // loop: true,
      // lopedSlides: 3,
      // spaceBetween: 0,
      // autoHeight: true,
      navigation: {
        nextEl: '.itemsBlog .swiper-button-next',
        prevEl: '.itemsBlog .swiper-button-prev',
      },
      pagination: {
        el: '.itemsBlog .swiper-pagination',
        type: 'fraction'
      },
      breakpoints: {
        [break_sm]: {
          slidesOffsetAfter: firstInnerWidth - itemBlogWidth
        },
        // [itemBlogWidth * 2]: {
        //   slidesOffsetAfter: firstInnerWidth - itemBlogWidth
        // },
      }
    }
  );
  // sliderBlog.snapGrid = [...sliderBlog.slidesGrid];
}())

